import { AxiosInstance } from 'axios';

import { ExpandPromiseResponse } from '@sv-support-sdk/shared-types/src/common/utils';

interface ScreenShareJoinRequest {
  id: number;
  hash: string;
}

interface ScreenShareJoinResponse {
  data: {
    channel: string;
    token: string;
  };
}

export default (api: AxiosInstance) => ({
  screenShareJoinClient: <T>({
    id,
    hash,
  }: ScreenShareJoinRequest): ExpandPromiseResponse<ScreenShareJoinResponse, T> =>
    api.post(`screen-sharing/chat/${id}/join-client`, undefined, {
      params: { hash },
      baseURL: api.defaults.baseURL?.replace('chat', 'v3'),
    }),
});
